import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { LocationModel } from './location.model';

export enum RoomType {
  Main = 'main',
  Preparation = 'preparation',
}

export const ROOM_TYPES = {
  main: 'rooms.types.main',
  preparation: 'rooms.types.preparation',
};

export class RoomModel extends BaseModel implements Deserializable {

  // columns
  location_id: number;
  active: boolean;
  name: string;
  type: RoomType;
  capacity?: number;
  zip?: string;
  street?: string;
  city?: string;
  country?: string;
  addition?: string;
  mail_registration: string;
  mail_catering?: string;
  blocked_days: Array<string>;

  // relations
  location: LocationModel;

  deserialize(input: any): this {
    Object.assign(this, input);
    // location
    if (this.location !== null && this.location !== undefined) {
      this.location = new LocationModel().deserialize(this.location);
    }
    return this;
  }

}
